import React from "react";
import { WhatsappLogo } from "@phosphor-icons/react";

/**
 * Floating WhatsApp support chat button.
 * Phone fallback is AfriPantry central support.
 */
export default function WhatsAppWidget({ phone = "+447979127731", message = "Hi! I'd like help with my AfriPantry order." }) {
  const url = `https://wa.me/${phone.replace(/\D/g, "")}?text=${encodeURIComponent(message)}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-chat-widget"
      className="fixed bottom-24 right-5 md:right-6 z-40 w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-[0_12px_30px_rgba(37,211,102,0.35)] hover:scale-110 active:scale-95 transition-transform"
      title="Chat on WhatsApp"
    >
      <WhatsappLogo size={28} weight="fill" />
    </a>
  );
}

export function WhatsAppShareButton({ phone = "+447979127731", message, className = "", label = "Share on WhatsApp", testid }) {
  if (!phone) return null;
  const url = `https://wa.me/${phone.replace(/\D/g, "")}?text=${encodeURIComponent(message || "")}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid || "whatsapp-share-btn"}
      className={`inline-flex items-center gap-2 rounded-full border border-[#25D366]/40 bg-[#25D366]/10 text-[#0a7034] px-4 py-2 text-xs font-semibold hover:bg-[#25D366]/20 transition-all ${className}`}
    >
      <WhatsappLogo size={16} weight="fill" /> {label}
    </a>
  );
}
